// 检查是否为管理员
export function isAdmin(email) {
  return email === 'zejia98@gmail.com';
}

// 检查是否有权限查看所有内容
export function canViewAll(email) {
  return isAdmin(email);
}

// 检查是否有权限管理精选内容
export function canManageFeatured(email) {
  return isAdmin(email);
} 